const info = 
{
    title: "Matthew24",
    type: "Script"
};

export default info;